export const environment = {
  TPS_API: 'https://pg.dev.sfey.com',
  IS_GOOGLE_PRODUCTION: false
};
